// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_AI_SUMMARY_BADGE = "Shrnut\u00ed diskuse";
export const FORUM_AI_SUMMARY_COMMENTS_count = "%(count)s p\u0159\u00edsp\u011bvk\u016f";
export const FORUM_AI_SUMMARY_DISCLAIMER = "Automatick\u00e9 shrnut\u00ed diskuse vygenerovan\u00e9 um\u011blou inteligenc\u00ed";
export const FORUM_AI_SUMMARY_HIDE = "Skr\u00fdt";
export const FORUM_AI_SUMMARY_SHOW = "Zobrazit cel\u00e9 shrnut\u00ed a \u010dast\u00e9 ot\u00e1zky";
